module.exports = __webpack_public_path__ + "media/src/application/media/svg/icon-29.3-d0609f03c14767d024b9cd357a4fcccc.svg";